import React, { useRef, useState, useEffect } from 'react';
import { View, Animated, TouchableWithoutFeedback, StyleSheet } from 'react-native';
import { Color, CommonProperties } from '../styles';
import BaseText from './BaseText';
import { scale } from '../utils/scale.utils';

const AnimatedSwitch = (props) => {
  const { onChangeType, labelLeft, labelRight, disabled, selectedOption } = props;
  const anim = useRef(new Animated.Value(0)).current;
  const [type, setType] = useState(0);

  useEffect(() => {
    if (selectedOption === 1) {
      setType(1);
      onChangeType(1);
      fadeOut();
    }
  }, [selectedOption]);

  const fadeIn = () => {
    Animated.timing(anim, {
      toValue: 0,
      duration: 300,
      useNativeDriver: false,
    }).start();
  };

  const fadeOut = () => {
    Animated.timing(anim, {
      toValue: scale(90),
      duration: 400,
      useNativeDriver: false,
    }).start();
  };

  const opacity = anim.interpolate({
    inputRange: [0, 20, 70, 90],
    outputRange: [1, 0, 0, 1],
  });

  return (
    <TouchableWithoutFeedback
      onPress={() => {
        if (disabled) {
          return;
        }
        if (type === 0) {
          setType(1);
          onChangeType(1);
          fadeOut();
        } else {
          setType(0);
          onChangeType(0);
          fadeIn();
        }
      }}
    >
      <View style={styles.container}>
        <BaseText style={styles.text}>{labelLeft}</BaseText>
        <BaseText style={styles.text}>{labelRight}</BaseText>
        <Animated.View
          style={[
            styles.movedView,
            {
              transform: [
                {
                  translateX: anim,
                },
              ],
              backgroundColor: disabled ? Color.disabled : Color.primary,
            },
          ]}
        >
          <Animated.Text style={[styles.movedText, { opacity: opacity }]}>
            {type === 0 ? labelLeft : labelRight}
          </Animated.Text>
        </Animated.View>
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    width: scale(180),
    borderColor: Color.text.low,
    borderWidth: 0.5,
    borderRadius: scale(24),
    height: scale(32),
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    width: '50%',
    textAlign: 'center',
    ...CommonProperties.h3,
    color: Color.primary,
  },
  movedText: {
    ...CommonProperties.h3,
    ...CommonProperties.fontFamily,
    color: Color.accent,
    textAlign: 'center',
  },
  movedView: {
    width: scale(90),
    position: 'absolute',
    zIndex: 1,
    elevation: 1,
    height: scale(32),
    borderRadius: scale(24),
    justifyContent: 'center',
    left: 0,
    ...CommonProperties.shadow,
  },
});

export default AnimatedSwitch;
